const mutations = {

    setInvoiceNumber(state, number) {
        state.invoiceNumber = number;
    }
}
export default mutations;